import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetSoilUnitsInputDto, SoilUnitCreateDto, SoilUnitDto, SoilUnitExcelDownloadDto, SoilUnitUpdateDto } from '../dtos/soil-unit/models';

@Injectable({
  providedIn: 'root',
})
export class SoilUnitService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: SoilUnitCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUnitDto>({
      method: 'POST',
      url: '/api/planning/soilUnits',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/soilUnits/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/soilUnits',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUnitDto>({
      method: 'GET',
      url: `/api/planning/soilUnits/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/soilUnits/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetSoilUnitsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<SoilUnitDto>>({
      method: 'GET',
      url: '/api/planning/soilUnits',
      params: { name: input.name, soilUnitArea: input.soilUnitArea, soilUnitAreaFrom: input.soilUnitAreaFrom, soilUnitAreaTo: input.soilUnitAreaTo, soilAptitudeId: input.soilAptitudeId, soilAptitudeName: input.soilAptitudeName, isForestPriority: input.isForestPriority, productivityIndex: input.productivityIndex, productivityIndexFrom: input.productivityIndexFrom, productivityIndexTo: input.productivityIndexTo, specificConsumptionTypeId: input.specificConsumptionTypeId, specificConsumptionTypeName: input.specificConsumptionTypeName, soilGroupId: input.soilGroupId, soilGroupName: input.soilGroupName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: SoilUnitExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/soilUnits/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, soilUnitArea: input.soilUnitArea, soilUnitAreaFrom: input.soilUnitAreaFrom, soilUnitAreaTo: input.soilUnitAreaTo, soilAptitudeId: input.soilAptitudeId, soilAptitudeName: input.soilAptitudeName, isForestPriority: input.isForestPriority, productivityIndex: input.productivityIndex, productivityIndexFrom: input.productivityIndexFrom, productivityIndexTo: input.productivityIndexTo, specificConsumptionTypeId: input.specificConsumptionTypeId, specificConsumptionTypeName: input.specificConsumptionTypeName, soilGroupId: input.soilGroupId, soilGroupName: input.soilGroupName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUnitDto[]>({
      method: 'GET',
      url: '/api/planning/soilUnits/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: SoilUnitUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SoilUnitDto>({
      method: 'PUT',
      url: `/api/planning/soilUnits/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}